import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, Check } from 'lucide-react';
const NAMES = ['Martín', 'Sofía', 'Alejandro', 'Valentina', 'Diego', 'Camila', 'Lucas', 'Isabella', 'Mateo', 'Lucía', 'Gabriel', 'Mariana'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Santiago', 'Lima', 'Bogotá', 'Medellín', 'Montevideo', 'Ciudad de México'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Cycle every 20 seconds
    const interval = setInterval(showPopup, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-19">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-xs w-full" data-id="element-20">
          <div className="bg-white rounded-lg shadow-xl p-4 flex items-center gap-4 border-l-4 border-green-500" data-id="element-21">
            <div className="bg-green-100 p-2 rounded-full" data-id="element-22">
              <ShoppingBag className="w-5 h-5 text-green-600" data-id="element-23" />
            </div>
            <div data-id="element-24">
              <p className="text-sm font-medium text-gray-900" data-id="element-25">
                <span className="font-bold" data-id="element-26">{data.name}</span> de {data.city}
              </p>
              <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-27">
                acaba de comprar el libro
                <Check className="w-3 h-3 text-green-500" data-id="element-28" />
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}